import { LoadingButton } from '@mui/lab';
import { Box, CardContent, Checkbox, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { api } from 'src/Api';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import dayjs from 'dayjs';
import { json } from 'react-router-dom';
import Alert from '@mui/material/Alert';

export default function OrderDiscountModal({
  handleClose,
  orderdiscount,
  refreshAdmin,
  fullWidth
}) {
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [startdate, setstartdate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [couponcode, setCouponCode] = useState('');
  const [value, setValue] = useState('');
  const [onetime, setOneTime] = useState(false);
  const [loading, setloading] = useState('');
  const [roles, setRoles] = useState([
    { id: 'Fixed', name: 'Fixed' },
    { id: 'Percentage', name: 'Percentage' }
  ]);
  const [alert, setalert] = useState({ visible: false, message: '' });

  function AddDeliveryFee() {
    setloading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    orderdiscount && formdata.append('id', orderdiscount?.id);
    formdata.append('name', name);
    type && formdata.append('type', type?.name);
    formdata.append('value', value);
    startdate !== null &&
      startdate?.startDate !== null &&
      formdata.append('start_date', dayjs(startdate?.startDate).format('YYYY-MM-DD'));
    enddate !== null &&
      enddate?.endDate !== null &&
      formdata.append('end_date', dayjs(enddate?.endDate).format('YYYY-MM-DD'));
    formdata.append('one_time', onetime ? '1' : '0');
    formdata.append('coupon_code', couponcode);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    setloading(true);
    fetch(orderdiscount ? api.edit_discount_order : api.add_discount_order, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  const handleChange = (event) => {
    const selectedRole = event.target.value;
    // setRole(selectedRole?.name);
    // setReasondrop(selectedRole);
    setType(selectedRole);

    setValue(selectedRole?.name?.toLowerCase() == 'fixed' ? '1' : '');
  };

  const handleStartDateChange = (newDate) => {
    setstartdate({
      startDate: newDate?.toDate() || null
    });
    setEndDate({
      endDate: null
    });
  };

  const handleEndDateChange = (newDate) => {
    setEndDate({
      endDate: newDate?.toDate() || null
    });
  };

  const handleChangechecked = (event) => {
    console.log('event change', event.target.checked);
    if (event.target.checked == true) {
      setOneTime(true);
    } else {
      setOneTime(false);
    }
  };

  useEffect(() => {
    if (orderdiscount) {
      setName(orderdiscount?.name);
      const selectedRole = roles.find((role) => role.id === orderdiscount?.type);
      setType(selectedRole);
      setValue(orderdiscount?.value);
      setCouponCode(orderdiscount?.coupon_code);

      orderdiscount.start_date &&
        setstartdate({
          startDate: dayjs(orderdiscount.start_date) // Convert the string to a dayjs object
        });
      orderdiscount.end_date &&
        setEndDate({
          endDate: dayjs(orderdiscount.end_date) // Convert the string to a dayjs object
        });
      setOneTime(orderdiscount?.one_time == '1' ? true : false);
    }
  }, []);

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t(orderdiscount ? 'Edit Discount' : 'Add Discount')}
      </Typography>
      <CardContent>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Name'}
                type="text"
                // type="number"
                value={name}
                onChange={(val) => {
                  setName(val.target.value);
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth={fullWidth}
                style={{ width: !fullWidth && '20%', marginLeft: !fullWidth && 15 }}
                select
                value={type}
                label={'Type'}
                onChange={handleChange}
              >
                <MenuItem value="" disabled>
                  Select a type
                </MenuItem>
                {roles.map((option) => (
                  <MenuItem key={option.id} value={option}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Box
              p={1}
              style={{
                flexDirection: 'column',
                display: 'flex',
                flex: 1,
                marginLeft: 5
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Start Date"
                    value={startdate?.startDate ? dayjs(startdate?.startDate) : null}
                    onChange={handleStartDateChange}
                    sx={{ width: '50%' }}
                    minDate={dayjs()}
                  />
                  <DatePicker
                    label="End Date"
                    value={enddate?.endDate && dayjs(enddate?.endDate)}
                    onChange={handleEndDateChange}
                    sx={{ width: '50%' }}
                    minDate={startdate?.startDate && dayjs(startdate?.startDate)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Value'}
                type="text" // Use "text" to allow custom validation
                value={value}
                onChange={(val) => {
                  let value = val.target.value;

                  if (type.name == 'Percentage') {
                    let sanitizedValue = value.replace(/[^0-9]/g, '');
                    if (sanitizedValue === '' || (sanitizedValue >= 0 && sanitizedValue <= 100)) {
                      setValue(sanitizedValue);
                    }
                  }
                  if (type.name !== 'Percentage') {
                    if (value == '') {
                      setValue('1');
                    } else {
                      let sanitizedValue = value.replace(/[^0-9]/g, '');

                      // Convert sanitizedValue to a number and check the range
                      let numericValue = parseInt(sanitizedValue, 10);

                      // Ensure the value is between 1 and 100000
                      if (numericValue < 1) {
                        numericValue = 1;
                      } else if (numericValue > 100000) {
                        numericValue = 100000;
                      }

                      // Update the state with the corrected value
                      setValue(numericValue.toString());
                    }
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Coupon Code'}
                type="text"
                value={couponcode}
                onChange={(val) => {
                  setCouponCode(val.target.value);
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
          </>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            p: 2,
            alignItems: 'center'
          }}
        >
          <Checkbox
            label="slkfnsdon"
            checked={onetime}
            onClick={(e) => {
              e.stopPropagation();
              handleChangechecked(e);
            }}
          />

          <Typography>Single Use</Typography>
        </Box>
        <Box></Box>
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </CardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            AddDeliveryFee();
          }}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          Cancel
        </LoadingButton>
      </Box>
    </Box>
  );
}
